import { dateToFilterFormat } from '@/composables/useDateService'

export const FacilityAssignmentPlanRule = (json: IFacilityAssignmentPlanRule): IFacilityAssignmentPlanRuleModel => {
	const { effective_from, target_facility_id, region_identifiers, region_forwarders } = json

	return {
		effectiveFrom: effective_from,
		targetFacilityId: target_facility_id,
		regionIdentifiers: region_identifiers ?? [],
		regionForwarders: region_forwarders ?? [],
	}
}

export const facilityAssignmentPlanRuleToJSON = (
	model: IFacilityAssignmentPlanRuleModel,
): IFacilityAssignmentPlanRule => ({
	effective_from: model.effectiveFrom,
	target_facility_id: model.targetFacilityId,
	region_identifiers: model.regionIdentifiers,
	region_forwarders: model.regionForwarders,
})

export const FacilityAssignmentPlan = (json: IFacilityAssignmentPlanPayload): IFacilityAssignmentPlanPayloadModel => ({
	rules: (json.rules ?? []).map(rule => FacilityAssignmentPlanRule(rule)),
})

export const facilityAssignmentPlanToJSON = (
	model: IFacilityAssignmentPlanPayloadModel,
): IFacilityAssignmentPlanPayload => ({
	rules: model.rules.map(rule => facilityAssignmentPlanRuleToJSON(rule)),
})

/** Ujemne ID z indeksu — unikalne na liście, bez kolizji hasha; nie kolidują z Date.now() przy nowych wpisach. */
const createStableAllocationId = (index: number): number => -(index + 1)

const resolveProductionUnitName = (targetFacilityId: string, productionUnits: IProductionUnitListItem[]): string => {
	const unit = productionUnits.find(productionUnit => productionUnit.targetFacilityId === targetFacilityId)

	return unit?.name ?? targetFacilityId
}

const formatEffectiveFrom = (dateFrom?: string): string => {
	if (!dateFrom) {
		return dateToFilterFormat(new Date())
	}

	const parsed = new Date(dateFrom)

	if (Number.isNaN(parsed.getTime())) {
		return dateFrom
	}

	return dateToFilterFormat(parsed)
}

export const mapFacilityAssignmentPlanToAllocations = (
	plan: IFacilityAssignmentPlanPayloadModel,
	productionUnits: IProductionUnitListItem[],
): IProductionAllocationListItem[] =>
	plan.rules.map((rule, index) => ({
		id: createStableAllocationId(index),
		productionUnit: resolveProductionUnitName(rule.targetFacilityId, productionUnits),
		targetFacilityId: rule.targetFacilityId,
		dateFrom: rule.effectiveFrom,
		regions: rule.regionIdentifiers,
		forwarders: rule.regionForwarders,
	}))

export const buildFacilityAssignmentPlanModel = (
	allocations: IProductionAllocationListItem[],
): IFacilityAssignmentPlanPayloadModel => ({
	rules: allocations.map(allocation => ({
		effectiveFrom: formatEffectiveFrom(allocation.dateFrom),
		targetFacilityId: allocation.targetFacilityId,
		regionIdentifiers: allocation.regions,
		regionForwarders: allocation.forwarders,
	})),
})
